import React, { useEffect, useState } from 'react'
import axios from 'axios';
import {Dropdown} from "primereact/dropdown"
import {ProgressSpinner} from "primereact/progressspinner"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { Avatar } from 'primereact/avatar';
import DriverInfo from './driver_info';
import TeamInfo from './team_info';
import 'primeicons/primeicons.css';
import "./style.css"

export const base_url = window.rccFrontend?.baseUrl || ""
const driver_standing = "Piloti"
const team_standing = "Squadre"

function apiRequest(url) {
  return axios.request({
    url,
    params: {
      _rcc: Date.now(),
    },
    headers: {
      'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  })
}

function renderAvatar(image, labelSeed, icon = "pi pi-user") {
  if(image) {
    return <Avatar image={image} size="normal" shape="circle" style={{overflow: 'hidden'}}/>
  }

  const label = (labelSeed || "?").toString().trim().charAt(0).toUpperCase()
  return <Avatar label={label || "?"} icon={icon} size="normal" shape="circle" style={{backgroundColor: "#e9ecef", color: "#495057"}}/>
}

function App() {
  const [championshipsList, setChampionshipsList] = useState([])
  const [selectedChampionship, setSelectedChampionship] = useState(null)
  const [editionsList, setEditionsList] = useState([])
  const [selectedEdition, setSelectedEdition] = useState(null)
  const [subcategoryList, setSubcategoryList] = useState([])
  const [selectedSubcategory, setSelectedSubcategory] = useState(null)
  const [subcategoryInfo, setSubcategoryInfo] = useState(null)
  const [standingType, setStandingType] = useState(driver_standing)
  const [selectedDriver, setSelectedDriver] = useState(null)
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [loading, setLoading] = useState(false)
  const [queryParams] = useState(Object.fromEntries(new URLSearchParams(window.location.search))) // { edition, championship, subcategory }

  useEffect(() => {
    setLoading(true)
      apiRequest(base_url + "/wp-json/race-championship/v1/campionati").then(({ data }) => {
      setChampionshipsList(data.data)
      let queryChampionship = data.data.filter(championship => championship['id'] === parseInt(queryParams['championship']))
      if(queryChampionship.length !== 0) {
        setSelectedChampionship(queryChampionship[0])
      } else {
        setSelectedChampionship(data.data[0])
      }
      setSelectedEdition(null)
      setSelectedSubcategory(null)
      setSubcategoryInfo(null)
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }, [queryParams])

  useEffect(() => {
    if(selectedChampionship != null) {
      setLoading(true)
      apiRequest(base_url + "/wp-json/race-championship/v1/edizioni?championship_id=" + selectedChampionship['id']).then(({ data }) => {
        setEditionsList(data.data)
        let queryEdition = data.data.filter(edition => edition['id'] === parseInt(queryParams['edition']))
        if(queryEdition.length !== 0){
          setSelectedEdition(queryEdition[0])
        } else {
          setSelectedEdition(data.data[0])
        }
        setSubcategoryInfo(null)
        setSelectedSubcategory(null)
        setLoading(false)
      }).catch(() => {
        setLoading(false)
      })
    }
  }, [selectedChampionship, queryParams])

  useEffect(() => {
    if(selectedEdition != null) {
      setLoading(true)
      apiRequest(base_url + "/wp-json/race-championship/v1/classi?edition_id=" + selectedEdition['id']).then(({ data }) => {
        setSubcategoryList(data.data)
        let querySubcategory = data.data.filter(subcategory => subcategory['id'] === parseInt(queryParams['subcategory']))
        if(querySubcategory.length !== 0) {
          setSelectedSubcategory(querySubcategory[0])
        } else {
          setSelectedSubcategory(data.data[0])
        }
        setSubcategoryInfo(null)
        setLoading(false)
      }).catch(() => {
        setLoading(false)
      })
    }
  }, [selectedEdition, queryParams])

  useEffect(() => {
    if(selectedSubcategory != null) {
      setSubcategoryInfo(null)
      setLoading(true)
      let url = standingType === driver_standing 
            ? base_url + "/wp-json/race-championship/v1/classifica-piloti?class_id=" + selectedSubcategory['id']
            : base_url + "/wp-json/race-championship/v1/classifica-squadre?class_id=" + selectedSubcategory['id']
      apiRequest(url).then(({ data }) => {
        data = data.data
        if(standingType === driver_standing) {
          const responseData = data
          data = responseData['drivers'] || []
          data = data.sort((a,b) => {
            if(a['total_points'] > b['total_points']) return -1
            if(a['total_points'] < b['total_points']) return 1
            return 0
          })
          data = data.map((value, i) => { return {...value, position: i + 1} })
          let max_points = Number(responseData['max']) || 0
          let race_names = responseData['race_names'] || []
          setSubcategoryInfo({drivers: data, max: max_points, race_names: race_names})
        } else {
          let team_list = data['teams'] || []
          team_list = team_list.sort((a,b) => {
            if(a['total_points'] > b['total_points']) return -1
            if(a['total_points'] < b['total_points']) return 1
            return 0
          })
          team_list = team_list.map((value, i) => { return {...value, position: i + 1} })
          let max_points = Number(data['max']) || 0
          let race_names = data['race_names'] || []
          let race_statuses = data['race_statuses'] || race_names.map(() => 'counting')
          setSubcategoryInfo({teams: team_list, max: max_points, race_names: race_names, race_statuses: race_statuses})
        }
        setLoading(false)
      }).catch(() => {
        setLoading(false)
      })
    }
  }, [selectedSubcategory, standingType])  

  return (
    <div className="App">
      <div className="grid">
        <div className="col-md-4 md:col-3 col-6">
          <h4 className="mb-2 mt-2">Campionato</h4>
          <Dropdown value={selectedChampionship} onChange={(e) => setSelectedChampionship(e.value)} options={championshipsList} optionLabel="name" placeholder="Seleziona un campionato" className="w-full" />
        </div>
        <div className="col-md-4 md:col-3 col-6">
          <h4 className="mb-2 mt-2">Edizione</h4>
          <Dropdown style={{ width: "100% !important"}} value={selectedEdition} onChange={(e) => setSelectedEdition(e.value)} options={editionsList} optionLabel="label" placeholder="Seleziona un'edizione" className="w-full" />
        </div>
        <div className="col-md-3 md:col-3 col-6">
          <h4 className="mb-2 mt-2">Categoria</h4>
          <Dropdown style={{ width: "100% !important"}} value={selectedSubcategory} onChange={(e) => setSelectedSubcategory(e.value)} options={subcategoryList} optionLabel="name" placeholder="Seleziona una categoria" className="w-full" />
        </div>
        <div className="md:col-1 col-12 align-content-end" style={{display: 'grid'}}>
            <ProgressSpinner
            style={{width: '30px', height: '30px', marginBottom: 12}}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
            className={loading ? "" : "hidden"}/>
        </div>
      </div>
      
      <div className="flex justify-content-center mb-2">
        <SelectButton value={standingType} onChange={(e) => e.value != null ? setStandingType(e.value) : () => {}} options={[driver_standing, team_standing]} />
      </div>
      {
        standingType === driver_standing ? 
          <DataTable scrollable columnResizeMode="fit" size="small" selection={selectedDriver} onSelectionChange={(e) => setSelectedDriver(e.value)} selectionMode="single" value={subcategoryInfo == null ? [] : subcategoryInfo['drivers']} >
              <Column field="position" header="Pos" footer={"Pos"} bodyStyle={{placeContent: 'center'}}></Column>
              <Column header="Foto" footer={"Foto"} bodyStyle={{placeContent: 'center'}} body={(driver) => renderAvatar(driver['image'], driver['name'])}></Column>
              <Column field="name" header="Pilota" footer={"Nome"} bodyStyle={{whiteSpace: 'nowrap', placeContent: 'center'}}></Column>
              <Column field="team" header="Team" footer={"Nome"} bodyStyle={{whiteSpace: 'nowrap', placeContent: 'center'}}></Column>
              {/* {
                subcategoryInfo == null ? "" :
                subcategoryInfo['race_names'].map((race_name) => <Column field={race_name} header={race_name} footer={race_name}></Column>)
              } */}
              <Column field="total_points" footer="Totale" header="Totale" alignFrozen="right" frozen={true} bodyStyle={{placeContent: 'center'}}></Column>
          </DataTable> :
          <DataTable scrollable columnResizeMode="fit" size="small" bodyStyle={{placeContent: 'center'}} selection={selectedTeam} onSelectionChange={(e) => setSelectedTeam(e.value)} selectionMode="single" value={subcategoryInfo == null ? [] : subcategoryInfo['teams']} >
            <Column field="position" header="Pos" footer={"Pos"} bodyStyle={{placeContent: 'center'}}></Column>
            <Column header="Foto" footer={"Foto"} bodyStyle={{placeContent: 'center'}} body={(team) => renderAvatar(team['image'], team['name'], "pi pi-users")}></Column>
            <Column field="name" header="Nome" footer={"Nome"} bodyStyle={{whiteSpace: 'nowrap', placeContent: 'center'}}></Column>
            {/* {
              subcategoryInfo == null ? "" :
              subcategoryInfo['race_names'].map((race_name) => <Column field={race_name} header={race_name} footer={race_name}></Column>)
            } */}
            <Column field="total_points" footer="Totale" header="Totale" alignFrozen="right" frozen={true} bodyStyle={{placeContent: 'center'}}></Column>
          </DataTable>
      }

      <DriverInfo 
        max={subcategoryInfo == null ? null : subcategoryInfo['max']}
        info={selectedDriver} 
        setInfo={setSelectedDriver} 
        races={subcategoryInfo == null ? null : subcategoryInfo['race_names']}/>
      <TeamInfo
        edition={selectedEdition}
        max={subcategoryInfo == null ? null : subcategoryInfo['max']}
        info={selectedTeam} 
        setInfo={setSelectedTeam} 
        races={subcategoryInfo == null ? null : subcategoryInfo['race_names']}
        statuses={subcategoryInfo == null ? null : subcategoryInfo['race_statuses']}/>
    </div>
  );
}

export default App;
